
import React from 'react';
import { DISPLAY_FORGOT_PASSWORD } from "../login-box/login-box";
import { css_file_to_url } from "../../helper/css-util";
import { ImgTint } from "../../components/img-tint";
import LoginBox from "../login-box";
import { ResetEmailState } from "../login-box/login-box";
import { resetPassword } from "../login/actions";

class ForgotPassword extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      reset_email_state: ResetEmailState.START,
    };
  }

  onSendResetEmail = email => {
    this.setState({
      reset_email_state: ResetEmailState.LOADING,
    });
    resetPassword(this.props.wlf_id, email)
      .then(() => {
        this.setState({
          reset_email_state: ResetEmailState.DONE,
        })
      });
  }

  render = () => {
    const client = this.props.client;
    const {
      color,
    } = client;

    const container_style = {
        zIndex: "5",
        //background: getRGB(color.top_panel_tint),
        height: "35rem",
    };

    const login_style = {
          marginTop: "2rem",
          marginBottom: "0.1rem",

    };
    const landing_page_url = css_file_to_url(this.props.config, client.landing_page_image);
    return (
      <div>
        <div className="container-style-responsive" style={container_style}>
          <ImgTint img={landing_page_url} tint={color.top_panel_tint} />
          { <LoginBox
            style={login_style}
            display={DISPLAY_FORGOT_PASSWORD}
            reset_email_state={this.state.reset_email_state}
            onSendResetEmail={this.onSendResetEmail}/> }
        </div>
      </div>
    );
  }
}

export { ForgotPassword };
